import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function GestaoContabil() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Gestão Contábil - N&N Soluções Empresariais | Contabilidade Completa em Goiânia';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Gestão contábil completa em Goiânia. Segurança e proteção total da contabilidade da sua empresa com foco em reduzir estresse e garantir melhores opções tributárias.');
    }

    const structuredData = {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "Gestão Contábil",
      "description": "Gestão contábil completa com foco em reduzir estresse e garantir melhores opções tributárias",
      "url": `${import.meta.env.VITE_SITE_URL || "https://example.com"}/servicos/gestao-contabil`,
      "provider": {
        "@type": "Organization",
        "name": "N&N Soluções Empresariais",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Av. Goiás, 606",
          "addressLocality": "Goiânia",
          "addressRegion": "GO",
          "postalCode": "74015-010",
          "addressCountry": "BR"
        }
      },
      "areaServed": "Goiânia",
      "serviceType": "Contabilidade"
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      const scripts = document.querySelectorAll('script[type="application/ld+json"]');
      scripts.forEach(script => {
        if (script.text.includes('Gestão Contábil')) {
          script.remove();
        }
      });
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Header/Navigation */}
      <header className="bg-white shadow-sm fixed w-full top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/3e6f8fcc8f2630e876a6bece5f75fd5d/1e6fcf1846e59e804b7269319d1935e6.png" 
                alt="N&N Soluções Empresariais" 
                className="h-16 w-auto cursor-pointer"
                onClick={() => navigate('/')}
              />
            </div>
            <nav className="hidden md:flex space-x-8">
              <button onClick={() => navigate('/')} className="text-gray-700 transition-colors cursor-pointer" style={{ color: '#72142B' }}>Home</button>
              <button onClick={() => navigate('/servicos')} className="text-gray-700 transition-colors cursor-pointer" style={{ color: '#72142B' }}>Serviços</button>
              <button onClick={() => navigate('/sobre')} className="text-gray-700 transition-colors cursor-pointer" style={{ color: '#72142B' }}>Sobre</button>
              <button onClick={() => navigate('/contato')} className="text-gray-700 transition-colors cursor-pointer" style={{ color: '#72142B' }}>Contato</button>
              <button onClick={() => navigate('/agendamento')} className="text-gray-700 transition-colors cursor-pointer" style={{ color: '#72142B' }}>Agendamento</button>
            </nav>
            <a 
              href="https://wa.me/5562993911090"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white px-6 py-2 rounded-full hover:opacity-90 transition-all duration-300 whitespace-nowrap cursor-pointer"
              style={{ backgroundColor: '#72142B' }}
            >
              Fale Conosco
            </a>
          </div>
        </div>
      </header>

      {/* Breadcrumb */}
      <div className="bg-gray-50 py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex" aria-label="Breadcrumb">
            <ol className="flex items-center space-x-4">
              <li>
                <button onClick={() => navigate('/')} className="text-gray-500 hover:text-gray-700 cursor-pointer">
                  Home
                </button>
              </li>
              <li>
                <i className="ri-arrow-right-s-line text-gray-400"></i>
              </li>
              <li>
                <button onClick={() => navigate('/servicos')} className="text-gray-500 hover:text-gray-700 cursor-pointer">
                  Serviços
                </button>
              </li>
              <li>
                <i className="ri-arrow-right-s-line text-gray-400"></i>
              </li>
              <li>
                <span className="font-medium" style={{ color: '#72142B' }}>Gestão Contábil</span>
              </li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Hero Section */}
      <section 
        className="relative py-32 overflow-hidden"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Professional%20accounting%20office%20with%20modern%20workspace%2C%20financial%20documents%20and%20ledger%20books%20on%20organized%20desk%2C%20calculator%20and%20computer%20showing%20accounting%20software%2C%20warm%20professional%20lighting%20creating%20trustworthy%20business%20environment%2C%20clean%20organized%20setup%20conveying%20expertise%20in%20financial%20management&width=1920&height=800&seq=gestao-contabil-hero&orientation=landscape')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-[#72142B]/80 via-[#72142B]/40 to-transparent"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6">
              Gestão Contábil
            </h1>
            <p className="text-xl text-white/90 mb-8">
              Segurança e proteção total da contabilidade da sua empresa com foco em reduzir estresse e garantir as melhores opções tributárias.
            </p>
            <a 
              href="https://wa.me/5562993911090"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 hover:transform hover:scale-105 whitespace-nowrap cursor-pointer"
              style={{ backgroundColor: '#FAF7F2', color: '#72142B' }}
            >
              Solicitar Orçamento
            </a>
          </div>
        </div>
      </section>

      {/* Serviço Detalhado */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl font-bold mb-6" style={{ color: '#72142B' }}>
                Por que escolher nossa Gestão Contábil?
              </h2>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                Quando você escolhe nossa equipe para lidar com a contabilidade de sua empresa, recebe mais do que experiência e visão. Recebe parceiros comprometidos em reduzir seu estresse e garantir as melhores opções tributárias.
              </p>
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-8 h-8 rounded-full flex items-center justify-center mr-4 mt-1" style={{ backgroundColor: '#72142B' }}>
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2" style={{ color: '#72142B' }}>Experiência Comprovada</h3>
                    <p className="text-gray-600">Mais de 10 anos de experiência em contabilidade empresarial</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 rounded-full flex items-center justify-center mr-4 mt-1" style={{ backgroundColor: '#72142B' }}>
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2" style={{ color: '#72142B' }}>Atendimento Personalizado</h3>
                    <p className="text-gray-600">Cada empresa é única e merece um tratamento diferenciado</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 rounded-full flex items-center justify-center mr-4 mt-1" style={{ backgroundColor: '#72142B' }}>
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2" style={{ color: '#72142B' }}>Tecnologia Avançada</h3>
                    <p className="text-gray-600">Utilizamos os melhores sistemas para garantir precisão e agilidade</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20accountant%20working%20with%20financial%20documents%20and%20calculator%20in%20modern%20office%2C%20organized%20desk%20with%20ledger%20books%20and%20computer%20showing%20accounting%20software%20interface%2C%20warm%20professional%20lighting%20conveying%20expertise%20and%20trust%20in%20financial%20services&width=600&height=500&seq=gestao-contabil-detail&orientation=landscape"
                alt="Gestão Contábil Profissional"
                className="w-full h-auto rounded-2xl shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Serviços Inclusos */}
      <section className="py-20" style={{ backgroundColor: '#FAF7F2' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-4" style={{ color: '#72142B' }}>
              O que está incluído
            </h2>
            <p className="text-xl text-gray-600">Serviços completos de gestão contábil</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{ backgroundColor: '#72142B' }}>
                <i className="ri-file-text-line text-xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3" style={{ color: '#72142B' }}>Escrituração Contábil</h3>
              <p className="text-gray-600">Registro de todas as operações da empresa conforme legislação vigente</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{ backgroundColor: '#72142B' }}>
                <i className="ri-calculator-line text-xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3" style={{ color: '#72142B' }}>Apuração de Impostos</h3>
              <p className="text-gray-600">Cálculo preciso de todos os tributos devidos pela empresa</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{ backgroundColor: '#72142B' }}>
                <i className="ri-line-chart-line text-xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3" style={{ color: '#72142B' }}>Demonstrações Financeiras</h3>
              <p className="text-gray-600">Balanço patrimonial e DRE para análise da situação financeira</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{ backgroundColor: '#72142B' }}>
                <i className="ri-shield-check-line text-xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3" style={{ color: '#72142B' }}>Compliance Fiscal</h3>
              <p className="text-gray-600">Garantia de cumprimento de todas as obrigações fiscais</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{ backgroundColor: '#72142B' }}>
                <i className="ri-file-chart-line text-xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3" style={{ color: '#72142B' }}>Relatórios Gerenciais</h3>
              <p className="text-gray-600">Informações estratégicas para tomada de decisões</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{ backgroundColor: '#72142B' }}>
                <i className="ri-customer-service-line text-xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3" style={{ color: '#72142B' }}>Suporte Especializado</h3>
              <p className="text-gray-600">Atendimento personalizado com contador dedicado</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section 
        className="py-20"
        style={{
          background: `linear-gradient(135deg, #72142B 0%, #8B1538 50%, #72142B 100%)`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Pronto para simplificar sua contabilidade?
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-3xl mx-auto">
            Entre em contato conosco e descubra como podemos ajudar sua empresa a ter uma gestão contábil eficiente e segura
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="https://wa.me/5562993911090"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 hover:transform hover:scale-105 whitespace-nowrap cursor-pointer"
              style={{ backgroundColor: '#FAF7F2', color: '#72142B' }}
            >
              Solicitar Orçamento
            </a>
            <button 
              onClick={() => navigate('/agendamento')}
              className="border-2 border-white text-white px-8 py-4 rounded-full hover:bg-white transition-all duration-300 whitespace-nowrap cursor-pointer text-lg font-semibold"
              style={{ borderColor: '#FAF7F2', color: '#FAF7F2' }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#FAF7F2';
                e.currentTarget.style.color = '#72142B';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.color = '#FAF7F2';
              }}
            >
              Agendar Consulta
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="text-white py-16" style={{ backgroundColor: '#72142B' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="col-span-1 md:col-span-2">
              <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
                N&N Soluções Empresariais
              </h3>
              <p className="text-white/80 mb-6">
                Simplificando sua contabilidade para você focar no que realmente importa.
              </p>
              <div className="space-y-2">
                <p className="flex items-center text-gray-300">
                  <i className="ri-phone-line mr-3"></i>
                  WhatsApp: (62) 99391-1090
                </p>
                <p className="flex items-center text-gray-300">
                  <i className="ri-mail-line mr-3"></i>
                  contato@nnsolucoes.com.br
                </p>
                <p className="flex items-center text-gray-300">
                  <i className="ri-map-pin-line mr-3"></i>
                  Av. Goiás, 606 - Setor Central, Goiânia - GO
                </p>
              </div>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">Links Úteis</h4>
              <ul className="space-y-2">
                <li><button onClick={() => navigate('/')} className="text-white/80 hover:text-white transition-colors cursor-pointer">Home</button></li>
                <li><button onClick={() => navigate('/servicos')} className="text-white/80 hover:text-white transition-colors cursor-pointer">Serviços</button></li>
                <li><button onClick={() => navigate('/sobre')} className="text-white/80 hover:text-white transition-colors cursor-pointer">Sobre</button></li>
                <li><button onClick={() => navigate('/contato')} className="text-white/80 hover:text-white transition-colors cursor-pointer">Contato</button></li>
                <li><button onClick={() => navigate('/agendamento')} className="text-white/80 hover:text-white transition-colors cursor-pointer">Agendamento</button></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">Nossos Serviços</h4>
              <ul className="space-y-2">
                <li><button onClick={() => navigate('/servicos/gestao-contabil')} className="text-white/80 hover:text-white transition-colors cursor-pointer">Gestão Contábil</button></li>
                <li><span className="text-white/80">BPO Financeiro</span></li>
                <li><span className="text-white/80">Departamento Pessoal</span></li>
                <li><span className="text-white/80">Consultoria Financeira</span></li>
                <li><span className="text-white/80">Declaração de Impostos</span></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-white/20 mt-12 pt-8 text-center">
            <p className="text-white/80">
              © 2024 N&N Soluções Empresariais. Todos os direitos reservados. | 
              <a href="https://readdy.ai/?origin=logo" className="hover:text-white ml-1 cursor-pointer" style={{ color: '#FAEBEA' }}>
                Website Builder
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
